import React from "react";
import {  SelectProps, Button } from "@mui/material";

export interface SelectTextInputInterface extends SelectProps {
  title: string;
  subOptions?: { value: string; label: string }[];
}

const IconButtonWithText = ({
  title,
  subOptions,
}: SelectTextInputInterface) => {
  return (
    <Button
      variant="outlined"
      className="font-black"
      style={{
        fontWeight: 400,
        height: 30,
        boxShadow: subOptions
          ? "0px 0.87px 3.47px 0px rgba(0, 0, 0, 0.25)"
          : undefined,
      }}
      startIcon={<i className="far fa-star" style={{ fontSize: 14 }} />}
      endIcon={subOptions && <i className="fal fa-chevron-down" />}
    >
      {title}
    </Button>
  );
};

export default IconButtonWithText;
